let common = [
   // 隐私协议
   {
    path: '/commonPrivacypolicy',
    name: 'commonPrivacypolicy',
    component: () => import('@/pages/common/privacypolicy.vue'),
    meta: {
      title: '隐私协议'
    }
  },
  // 用户服务协议
  {
    path: '/commonUserAgreement',
    name: 'commonUserAgreement',
    component: () => import('@/pages/common/userAgreement.vue'),
    meta: {
      title: '用户协议'
    }
  },
  // ios隐私协议
  {
    path: '/commonPrivacypolicy_ios',
    name: 'commonPrivacypolicy_ios',
    component: () => import('@/pages/common/privacypolicy_ios.vue'),
    meta: {
      title: '隐私协议'
    }
  },
  // ios用户服务协议
  {
    path: '/commonUserAgreement_ios',
    name: 'commonUserAgreement_ios',
    component: () => import('@/pages/common/userAgreement_ios.vue'),
    meta: {
      title: '用户协议'
    }
  },
  // ios充值服务协议
  {
    path: '/rechargeAgreement_ios',
    name: 'rechargeAgreement_ios',
    component: () => import('@/pages/common/ios_recharge_agreement.vue'),
    meta: {
      title: '充值服务协议'
    }
  },
  // 充值服务协议
  {
    path: '/rechargeAgreement',
    name: 'rechargeAgreement',
    component: () => import('@/pages/common/rechargeAgreement.vue'),
    meta: {
      title: '充值服务协议'
    }
  },
  // sdk文档
  {
    path: '/commonSdk',
    name: 'commonSdk',
    component: () => import('@/pages/common/sdk.vue'),
    meta: {
      title: '第三方sdk说明'
    }
  },
    // ios 进圈sdk文档
    {
      path: '/commonSdk_ios',
      name: 'commonSdk_ios',
      component: () => import('@/pages/common/sdk_ios.vue'),
      meta: {
        title: '第三方sdk说明'
      }
    },
  // 权限申请与使用情况说明
  {
    path: '/commonPermission',
    name: 'commonPermission',
    component: () => import('@/pages/common/permission.vue'),
    meta: {
      title: '权限申请与使用情况说明'
    }
  },
  // 领队版违规处理说明
  {
    path: '/commonViolationanDling',
    name: 'commonViolationanDling',
    component: () => import('@/pages/common/violationanDling.vue'),
    meta: {
      title: '领队违规处理说明'
    }
  }, 
  // 社区规范
  {
    path: '/commonCommunityNorms',
    name: 'commonCommunityNorms',
    component: () => import('@/pages/common/communityNorms.vue'),
    meta: {
      title: '平台规范'
    }
  },
  // 相关许可证
  {
    path: '/commonRelevantLicenses',
    name: 'commonRelevantLicenses',
    component: () => import('@/pages/common/relevantLicenses.vue'),
    meta: {
      title: '相关许可证'
    }
  },
  // 平台行为规范
  {
    path: '/commonUserBehaviorSpecifications',
    name: 'commonUserBehaviorSpecifications',
    component: () => import('@/pages/common/userBehaviorSpecifications.vue'),
    meta: {
      title: '平台行为规范'
    }
  },
  // 语音房服务协议
  {
    path: '/commonVoiceRoomProtocol',
    name: 'commonVoiceRoomProtocol',
    component: () => import('@/pages/common/standard/voiceRoomProtocol.vue'),
    meta: {
      title: '语音房服务协议'
    }
  },
  // 语音房管理规范
  {
    path: '/commonVoiceRoomSpecification',
    name: 'commonVoiceRoomSpecification',
    component: () => import('@/pages/common/standard/voiceRoomSpecification.vue'),
    meta: {
      title: '语音房管理规范'
    }
  },
  // 主播入驻协议
  {
    path: '/commonHostAdmissionProtocol',
    name: 'commonHostAdmissionProtocol',
    component: () => import('@/pages/common/standard/hostAdmissionProtocol.vue'),
    meta: {
      title: '主播入驻协议'
    }
  },
  // 违规处罚规则
  {
    path: '/commonPenaltiesViolationsRulel',
    name: 'commonPenaltiesViolationsRulel',
    component: () => import('@/pages/common/standard/penaltiesViolationsRule.vue'),
    meta: {
      title: '违规处罚规则'
    }
  },
  // 违规处罚公告
  {
    path: '/commonPenaltiesViolationsNotice',
    name: 'commonPenaltiesViolationsNotice',
    component: () => import('@/pages/common/standard/penaltiesViolationsNotice.vue'),
    meta: {
      title: '违规处罚公告'
    }
  },
  // 违规举报处理机制
  {
    path: '/commonReportingViolations',
    name: 'commonReportingViolations',
    component: () => import('@/pages/common/standard/reportingViolations.vue'),
    meta: {
      title: '违规举报处理机制'
    }
  },
  // 客服规范手册
  {
    path: '/commonServiceManual',
    name: 'commonServiceManual',
    component: () => import('@/pages/common/standard/serviceManual.vue'),
    meta: {
      title: '客服规范手册'
    }
  },
  // 屏蔽字词库
  {
    path: '/commonShield',
    name: 'commonShield',
    component: () => import('@/pages/common/standard/shield.vue'),
    meta: {
      title: '屏蔽字词库'
    }
  },
  // 产品风控规范
  {
    path: '/commonProductRiskControl',
    name: 'commonProductRiskControl',
    component: () => import('@/pages/common/standard/productRiskControl.vue'),
    meta: {
      title: '产品风控规范'
    }
  },
  // 违规公告列表
  {
    path: '/commonViolationPublicityList',
    name: 'commonViolationPublicityList',
    component: () => import('@/pages/common/violationPublicityList.vue'),
    meta: {
      title: '违规公告'
    }
  },
  // 违规公示
  {
    path: '/commonViolationPublicityDetail',
    name: 'commonViolationPublicityDetail',
    component: () => import('@/pages/common/violationPublicityDetail.vue'),
    meta: {
      title: '违规公示'
    }
  },
  // 文章详情securityCenter
  {
    path: '/commonSecurityCenter',
    name: 'commonSecurityCenter',
    component: () => import('@/pages/common/securityCenter.vue'),
    meta: {
      title: 'helper'
    }
  },
  //小组长组CP任务详情
  {
    path: '/commonTaskDetails',
    name: 'commonTaskDetails',
    component: () => import('@/pages/common/taskDetails'),
    meta: {
      title: '任务详情'
    }
  },
  // 机审任务详情（下架）
  // {
  //   path: '/commonAuditTask',
  //   name: 'commonAuditTask',
  //   component: () => import('@/pages/common/auditTask'),
  //   meta: {
  //     title: '任务详情'
  //   }
  // },
  // 家族管理者红线规则
  {
    path: '/familyManagerRedLineRules',
    name: 'familyManagerRedLineRules',
    component: () => import('@/pages/common/familyManagerRedLineRules'),
    meta: {
      title: '家族管理者红线规则'
    }
  },
  // 小程序隐私协议
  {
    path: '/privacypolicy_applet',
    name: 'privacypolicy_applet',
    component: () => import('@/pages/common/privacypolicy_applet.vue'),
    meta: {
      title: '隐私协议'
    }
  },
  // 小程序用户协议
  {
    path: '/userAgreement_applet',
    name: 'userAgreement_applet',
    component: () => import('@/pages/common/userAgreement_applet.vue'),
    meta: {
      title: '用户协议'
    }
  },
  // 自由职业者服务协议
  {
    path: '/freelancer',
    name: 'freelancer',
    component: () => import('@/pages/common/freelancer.vue'),
    meta: {
      title: '自由职业者服务协议'
    }
  },
  {
    path: '/userAgreementQinmi',
    name: 'userAgreementQinmi',
    component: () => import('@/pages/agreement/userAgreementQinmi.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/userAgreementKaituan',
    name: 'userAgreementKaituan',
    component: () => import('@/pages/agreement/userAgreementKaituan.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/userAgreementJinquan',
    name: 'userAgreementJinquan',
    component: () => import('@/pages/agreement/userAgreementJinquan.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/userAgreementOuyya',
    name: 'userAgreementOuyya',
    component: () => import('@/pages/agreement/userAgreementOuyya.vue'),
    meta: {
      title: '用户协议'
    }
  },
  // 第三方SDK信息共享清单
  {
    path: '/thirdPartyShareList',
    name: 'thirdPartyShareList',
    component: () => import('@/pages/common/thirdPartyShareList.vue'),
    meta: {
      title: '第三方SDK信息共享清单'
    }
  },
]

export {
  common
}